import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { APP_NAME, RELEASE_VERSION } from '../../config/release';

interface AuthVersionLabelProps {
  logoutMessage?: string;
}

const AuthVersionLabel: React.FC<AuthVersionLabelProps> = ({ logoutMessage }) => {
  return (
    <Box sx={{ mt: 2, width: '100%', maxWidth: 600, textAlign: 'center' }}>
      {logoutMessage && (
        <Alert
          icon={<InfoOutlinedIcon fontSize="inherit" />}
          severity="info"
          data-cy="logout-message"
          sx={{
            mb: 1.25,
            textAlign: 'left',
            alignItems: 'flex-start',
            borderRadius: 2,
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
        >
          {logoutMessage}
        </Alert>
      )}
      <Typography
        variant="caption"
        align="center"
        sx={{ color: 'text.secondary', opacity: 0.8, display: 'block' }}
      >
        {APP_NAME} Version {RELEASE_VERSION}
      </Typography>
    </Box>
  );
};

export default AuthVersionLabel;
